let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4uhlL")).then(() => parcelRequire('ior5s'));